module.exports = __webpack_public_path__ + "static/img/malcaca.1555125.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/malcaca.png
// module id = 219
// module chunks = 1